import { render, staticRenderFns } from "./InvoiceRecordForm.vue?vue&type=template&id=95f56bf2&scoped=true"
import script from "./InvoiceRecordForm.vue?vue&type=script&lang=js"
export * from "./InvoiceRecordForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecordForm.vue?vue&type=style&index=0&id=95f56bf2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f56bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f56bf2')) {
      api.createRecord('95f56bf2', component.options)
    } else {
      api.reload('95f56bf2', component.options)
    }
    module.hot.accept("./InvoiceRecordForm.vue?vue&type=template&id=95f56bf2&scoped=true", function () {
      api.rerender('95f56bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceRecord/InvoiceRecordForm.vue"
export default component.exports